import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Grid, Card, LinearProgress } from '@mui/material';
import EventCard from '../event/eventsCard';
import { useParams } from 'react-router-dom';

function ActDetail() {
  const { id } = useParams();
  // const stringifiedUser = localStorage.getItem('user');
  // const user = JSON.parse(stringifiedUser);
  const act = useSelector((state) => state.activity.activity);
  const [isLoading, setisLoading] = useState(true);
  const [eventData, setEventData] = useState([]);
  const [volCount, setVolCount] = useState(0);
  const [totalCredExchange, setTotalCredExchange] = useState(0);

  // const addUser = () => {
  //   const body = [
  //     {
  //       from_user: userID,
  //       to_user: act['founder'],
  //       creds: '0',
  //       program_name: act['title'],
  //       program: act['id'],
  //       hours: '0',
  //       message: `${user['first_name']} ${user['last_name']} wants to join your program ${act['title']}`,
  //       notif_type: 1,
  //     },
  //   ];
  //   dispatch(sendNotif(token, body, act['founder']));
  // };


  useEffect(() => {
    fetch(
      process.env.REACT_APP_API_URL +
      `/api/program/events/view?program_id=${id}`,
      {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        body: JSON.stringify(),
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setEventData(data.response.response_data);
        setTotalCredExchange(data.response.response_data[0]['CredsExchanged']);
        setVolCount(data.response.response_data[0]['Total Volunteers']);
        setisLoading(false);
      })
      .catch((err) => {
        //console.log(err);
      });
    // eslint-disable-next-line



    // eslint-disable-next-line 
  }, []);

  if (!isLoading) {
    return (
      <div>
        {act ? (
          <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
              <Card>
                <Grid item xs={12} md={12} >
                  <Grid>
                    <EventCard m={4} programID={id} eventData={eventData} volCount={volCount} totalCredExchange={totalCredExchange} />
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        ) : (
          ""
        )}
      </div>
    );
  } else {
    return (
      <div style={{ marginTop: 20, textAlign: 'center' }}>
        <img alt={'logo'} style={{ height: 350, width: 300 }} src={`${process.env.REACT_APP_R2_URL}/general/time_creds_logo.png`} />
        <LinearProgress />
      </div>
    );
  }
}

export default ActDetail;
